import styled from "styled-components";
import { NavLink as Base } from "react-router-dom";

export const StyledNavLink = styled(Base)`
  display: flex;
  align-items: center;
  padding: 12px 25px;
  
  font-size: 16px;
  font-weight: 600;
  
  color: ${({ theme: { colors } }) => colors["zodiac"]};
  text-decoration: none;
  
  & > span {
    display: inline-block;
    margin-left: 17px;
  }
  
  &.active {
    background-color: aliceblue;
  }
`;
